import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import EmptyList from "go-core/components/EmptyList";
import { OrganizationPartnerInfoApi } from "../../../../../../../services/Api/Admin/adminTypes";
import OrganizationSinglePartnerItem from "../OrganizationSinglePartnerItem";

interface Props {
	partners: OrganizationPartnerInfoApi[];
}

const PartnersTabPreview = ({ partners }: Props) => {
	const { t } = useTranslation("admin");
	return (
		<div>
			{partners.length > 0 ? (
				<>
					{partners.map((partner, index) => (
						<OrganizationSinglePartnerItem partner={partner} key={`partner-${index}`} size={"large"} />
					))}
				</>
			) : (
				<Card>
					<Card.Body>
						<EmptyList
							title={t("common.word.partners")}
							description={t("modules.organization.field.no_partners.description")}
						/>
					</Card.Body>
				</Card>
			)}
		</div>
	);
};

export default PartnersTabPreview;
